import { addSeconds, endOfDay, format, setMilliseconds } from "date-fns";
import { trimEnd } from "lodash";

import { DateFormat } from "constants/date";

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function mapDateRange(from: string | Date | null, to: string | Date | null) {
  return {
    ...(from && {
      "range.from": typeof from === "string" ? from : format(from, DateFormat.ISO),
    }),
    ...(to && {
      "range.to": typeof to === "string" ? to : format(setMilliseconds(addSeconds(endOfDay(to), 1), 0), DateFormat.ISO),
    }),
  };
}

export const generateErrorMessage = (
  response: Response,
  errorBody: string | Record<string, unknown>,
  method: string,
  path: string,
  requestBody: BodyInit | undefined
): string => {
  const errorMessage = [
    `${method} ${trimEnd(path, "?")}`,
    ...(requestBody ? [`Request body: ${JSON.stringify(requestBody, null, 2)}`] : []),
    `Status: ${response.status}`,
    `Request ID: ${response.headers.get("x-helpdesk-request-id") || "unknown - error might've originated outside of HelpDesk"}`,
    `Error body: ${JSON.stringify(errorBody, null, 2)}`,
  ].join("\n");
  return errorMessage;
};
